module.exports = __webpack_public_path__ + "img/es-pc-banner.c7b66bba.png";